import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface IIntentItem {
  title: string;
  intent?: {
    id: string;
    name: string;
    matchedEntity?: string;
  };
}

export interface IIntentSelector {
  id: string;
  type: MESSAGES.INTENT_SELECTOR;
  rm: boolean;
  nodeId: string;
  items: IIntentItem[];
  role?: boolean;
}

export const createIntentSelector = (data): IIntentSelector => ({
  id: data.id || uuid(),
  type: MESSAGES.INTENT_SELECTOR,
  rm: Boolean(data.rm),
  nodeId: data.nodeId,
  items: data.items,
});
